import { render, staticRenderFns } from "./LmDocumentMovements.vue?vue&type=template&id=23d543a8&scoped=true"
import script from "./LmDocumentMovements.vue?vue&type=script&lang=js"
export * from "./LmDocumentMovements.vue?vue&type=script&lang=js"
import style0 from "./LmDocumentMovements.vue?vue&type=style&index=0&id=23d543a8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d543a8",
  null
  
)

export default component.exports